import React from 'react';
import styled from 'styled-components';

import {
    Paragraph,
    MessagePropType,
    Sizes,
    Colours,
    Typography,
} from '@ratehub/base-ui';


function SectionHeader({ message, ...otherProps }) {
    return (
        <Paragraph
            forwardedAs="h4"
            weight="medium"
            size="large"
            message={message}
            {...otherProps}
        />
    );
}

SectionHeader.propTypes = {
    message: MessagePropType.isRequired,
};


const StyledSectionHeader = styled(SectionHeader)`
    margin-top: 0;
    margin-bottom: ${Sizes.SPACING.HALF};
    color: ${Colours.STONE_DARKEST};

    font-size: ${Sizes.FONTS.S};
    font-weight: ${Typography.WEIGHTS.REGULAR};
`;

export default StyledSectionHeader;
